import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ConformationCodeError {
    alphaNumericLength: boolean;
  }
// this function validates the conformation code entered by user
  export function ConformationCodeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const conformationCodeError = new ConformationCodeError();
    let valid = true;
    if(value) {
    // This checks that length of conformation code must be 6 and it should contain alpha numeric values
const ALPHANUMERIC_LENGTH_REGEX = /^[a-zA-Z0-9]{6}$/;

if (!ALPHANUMERIC_LENGTH_REGEX.test(value)) {
    valid = false;
    conformationCodeError.alphaNumericLength = true;
  }
  if(valid) {
return null;
  } else return {conformationcode :conformationCodeError};  
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/update-profile/validators/conformation-code-validator.ts